<template>
  <div class="bg-white rounded-2xl shadow hover:shadow-md transition border border-[#e0dcd6] p-5 flex flex-col">
    <!-- Avatar + Info -->
    <div class="flex items-start gap-3 mb-4">
      <img
        :src="avatarUrl"
        :alt="provider.name"
        class="w-14 h-14 rounded-full object-cover border-2 border-[#b99a52] flex-shrink-0"
      />
      <div class="flex-1 min-w-0">
        <h3 class="font-semibold text-[#152a34] truncate">{{ provider.name }}</h3>
        <p v-if="provider.headline" class="text-xs text-gray-500 truncate">{{ provider.headline }}</p>
        <div class="flex items-center gap-1 mt-1">
          <span class="text-yellow-400 text-xs">★</span>
          <span class="text-xs text-gray-600 font-medium">{{ ratingDisplay }}</span>
          <span class="text-xs text-gray-400">({{ provider.reviews_count || 0 }} avaliações)</span>
        </div>
      </div>
    </div>

    <!-- Distância e localização -->
    <div class="flex items-center gap-4 text-xs text-gray-500 mb-3">
      <span v-if="provider.distance_km" class="flex items-center gap-1">
        <span class="mdi mdi-map-marker text-[#b99a52]"></span>
        {{ distanceDisplay }}
      </span>
      <span v-if="provider.city" class="flex items-center gap-1">
        <span class="mdi mdi-city text-gray-400"></span>
        {{ provider.city }}<span v-if="provider.state">/{{ provider.state }}</span>
      </span>
    </div>

    <!-- Projetos concluídos -->
    <div v-if="provider.projects_completed > 0" class="text-xs text-gray-400 mb-3 flex items-center gap-1">
      <span class="mdi mdi-check-circle text-green-500"></span>
      {{ provider.projects_completed }} serviço(s) realizado(s)
    </div>

    <div class="flex-1"></div>

    <!-- Botão -->
    <router-link
      :to="{ name: 'provider-profile', params: { hash: provider.hash } }"
      class="mt-3 block text-center py-2 bg-[#b99a52] text-white rounded-xl text-sm font-semibold hover:bg-[#a08840] active:scale-[0.99] transition flex items-center justify-center gap-1.5"
    >
      <span class="mdi mdi-calendar-check text-base"></span>
      Ver serviços e agendar
    </router-link>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  provider: { type: Object, required: true }
})

const storageUrl = import.meta?.env?.VUE_APP_URL_API_STORAGE || process.env.VUE_APP_URL_API_STORAGE || ''

const avatarUrl = computed(() => {
  if (!props.provider.avatar) return 'https://ui-avatars.com/api/?name=' + encodeURIComponent(props.provider.name)
  if (props.provider.avatar.startsWith('http')) return props.provider.avatar
  return `${storageUrl}/${props.provider.avatar}`
})

const ratingDisplay = computed(() => {
  const r = parseFloat(props.provider.rating_average || 0)
  return r > 0 ? r.toFixed(1) : 'Novo'
})

const distanceDisplay = computed(() => {
  const d = parseFloat(props.provider.distance_km || 0)
  if (d < 1) return `${Math.round(d * 1000)} m`
  return `${d.toFixed(1)} km`
})
</script>
